<template>
  <span v-if="instance">
    <v-row align="center" justify="center" class="fill-height fill-width fluid landing ma-0" :style="instanceBackground">
      <v-col xs="12" sm="8" md="6" lg="4" class="pa-sm-0 mx-auto">
        <v-card class="elevation-12 pt-6 mx-auto rounded-lg" rounded="0" min-width="480" theme="light" max-width="550">
          <v-card-title v-if="logo" class="mx-4">
            <a :href="showPlatformSignup ? 'https://carelaunch.health' : '/'" class="mx-auto cursor-pointer">
              <failover-image :alt="instance.name" class="shrink ma-auto mb-0" :src="logo" max-width="320" height="120" />
            </a>
          </v-card-title>
          <v-card-text class="pa-0">
            <authenticator ref="login-authenticator" key="login-authenticator" initial-state="signIn" :hide-sign-up="true">
              <template #sign-in-footer>
                <p class="ml-8">
                  <v-checkbox v-model="rememberDev" density="compact" label="Remember Device"></v-checkbox>
                </p>
                <p class="text-center pb-4">
                  <v-btn variant="text" color="primary" size="small" @click="toResetPassword">reset Password</v-btn>
                  <v-btn v-if="features?.registration" variant="text" color="primary" size="small" @click="register">Create Account</v-btn>
                </p>
              </template>
              <template #default="{ user, signOut }">
                <p class="text-center">
                  <span class="text-h6">Welcome</span>
                </p>
                <p class="text-center">
                  <v-btn variant="text" color="primary" size="small" @click="signOut">sign out</v-btn>
                </p>
              </template>
            </authenticator>
          </v-card-text>
          <v-card-actions v-if="showPlatformSignup" class="">
            <v-spacer></v-spacer>
            New to the platform?
            <v-btn variant="text" class="" color="primary" size="large" to="/signup">Sign Up Free</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-footer v-if="instance && instance.contactInfo" absolute class="font-weight-light">
      <v-col class="text-center" cols="12">{{ instance.contactInfo }}</v-col>
    </v-footer>
  </span>
</template>
<script setup>
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-vue";
import "@aws-amplify/ui-vue/styles.css";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { rememberDevice } from "@utils/auth-helper";

const router = useRouter();
const store = useStore();
const { route, user, authStatus, toResetPassword } = toRefs(useAuthenticator());
const instances = toRefs(store.state.instances);
const { organization } = toRefs(store.state.organization);
const instance = instances.instance;
const features = inject("features");
const rememberDev = ref(true);

const instanceBackground = computed(() => {
  let backgroundUrl = instance?.value?.backgroundUrl ?? organization?.value?.backgroundUrl ?? "/bg.jpg";
  if (!backgroundUrl) {
    return {
      "background-color": instance.value?.backgroundColor ?? organization.value?.backgroundColor ?? "#424242",
    };
  }
  return {
    "background-image": `url(${backgroundUrl})`,
  };
});

const logo = computed(() => {
  return instance?.value?.logo ?? organization?.value?.logo ?? "/CareLaunch-Logo.png";
});
const showPlatformSignup = computed(() => {
  return organization?.value?.organizationID == "Sales";
});

const register = () => {
  window.location.href = "/register";
};

watch([route, user], async ([newRoute, newUser], [oldRoute, oldUser]) => {
  if (newRoute === "authenticated" && newUser) {
    try {
      if (rememberDev.value) {
        await rememberDevice();
      }
      await store.dispatch("auth/SET_USER", newUser);
      let redirect = localStorage.getItem('redirectPath') || router.currentRoute.query?.redirect;

      let groups = newUser.signInUserSession.accessToken.payload["cognito:groups"];
      if (groups?.length > 0) {
        await router.push(redirect ?? "/home"); // redirect to /home
      } else {
        //get the newUser attribute custom:patients
        let patients = newUser.attributes["custom:patients"];
        let patientID = (newUser.attributes["custom:patientID"] ?? typeof patients === "string") ? patients : patients?.[0];

        if (!patientID) {
          await router.push("/portal/");
          return;
        }
        await router.push("portal/" + patientID);
      }
    } catch (error) {
      console.error("Authentication error:", error);
      // Handle error appropriately
    }
  }
});
</script>
<style lang="scss">
@import "@/assets/scss/main.scss";
</style>
<style scoped>
.landing {
  background: no-repeat center center;
  background-size: cover !important;
}

.v-footer {
  background-color: rgba(245, 245, 245, 0.8);
  overflow: hidden;
}

.v-application .grey.darken-3 {
  background-color: #424242d1 !important;
  border-color: #424242d1 !important;
}
</style>
